"use client";

import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Info } from "lucide-react";
import type { StatistikyZostavy as StatistikyZostavyType } from "@/types/database";
import { StatistikyZostavy } from "@/components/zoh/voting/hrac-info-statistiky";

import { cn } from "@/lib/utils";

interface AnalysisViewProps {
  statistiky: StatistikyZostavyType | null;
}

export function AnalysisView({ statistiky }: AnalysisViewProps) {
  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
        <div className="p-3 bg-status-info/15 rounded-xl text-status-info shrink-0 w-fit">
          <BarChart3 className="h-6 w-6" />
        </div>
        <div className="space-y-1">
          <h2
            className={cn(
              "text-2xl md:text-3xl font-bold tracking-tight",
              "bg-linear-to-r from-brand-gradient-from to-brand-gradient-to",
              "bg-clip-text text-transparent",
            )}
          >
            Analýza nominácie
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Kompletný prehľad kvality najúspešnejšej zostavy podľa komunity
          </p>
        </div>
      </div>
      <StatistikyZostavy statistiky={statistiky} narodeniny={[]} />

      <Card className="border-status-warning/20 bg-status-warning/5">
        <CardContent className="p-6 flex items-start gap-4">
          <Info className="h-6 w-6 text-status-warning shrink-0 mt-1" />
          <div>
            <h4 className="font-bold text-foreground">
              Pripravujeme detailnú analýzu
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed mt-1">
              Pre tento pohľad momentálne rozširujeme dátovú štruktúru výsledkov
              o vek a sezónne štatistiky. Čoskoro tu nájdete kompletný dashboard
              kvality najúspešnejšej fanúšikovskej zostavy.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
